export default __webpack_public_path__ + "static/media/Poppins-Italic.e373f616.ttf";